import { useIDBKeyval } from "@vueuse/integrations/useIDBKeyval";
import type { SpecificationMetadataState } from "types";
import type { Ref } from "vue";

const { data } = useIDBKeyval<SpecificationMetadataState[]>(
  "cleaningSpecifications",
  [],
  {
    shallow: false,
  }
);
export function useCleaningSpecificationsState(): Ref<
  SpecificationMetadataState[]
> {
  return data;
}
